export default __webpack_public_path__ + "static/media/go_to_market_target_audience_preview.de76d8f4.png";